<template>
    <!-- **************************** -->
    <!-- EL menú de navegación        -->
    <!-- **************************** -->
    <v-navigation-drawer
        v-if="isLogged"
        color="primary"
        dark
        app
        v-model="drawer"
        src="/images/NavBack.jpg"
        width="200"
    >
        <v-list-item :to="{path: '/principal'}">
            <v-list-item-content >
                <v-img contain height="100" src="/images/SantaFeBlanco.png"></v-img>
            </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>
        <v-list
            dense
            nav
            shaped
        >
        <div
            v-for="item in items"
            :key="item.title"
        >
            <v-list-item
                :to="{path: item.route}"
                link
                v-if="$store.state.security.roles.includes(item.role)"
            >
                <div class="d-flex flex-row" >
                    <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                </div>
            </v-list-item>
        </div>
        <!-- El link para drugs.com -->
        <div>
            <v-list-item
                href="https://www.drugs.com/drug-interactions/" target="_blank"
            >
                <v-list-item-icon>
                    <v-icon>mdi-pill</v-icon>
                </v-list-item-icon>
    
                <v-list-item-content>
                    <v-list-item-title>Interacciones Med</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </div>





        </v-list>
    </v-navigation-drawer>
</template>

<script>
export default {
    props:{
        drawerNavega:{
            type:Boolean
        }
    },
    data:()=>({
        items: [
            { title: 'Reportes', icon: 'mdi-chart-line-stacked', route: '/reportes/main',role:'ROLE_PACIENTES'},
            { title: 'Ocupación', icon: 'mdi-format-list-text', route: '/internados',role:'ROLE_PACIENTES'},
            { title: 'Medicamentos', icon: 'mdi-pill', route: '/medicamentos',role:'ROLE_PACIENTES'},
            { title: 'Pacientes', icon: 'mdi-account-group', route: '/pacientes',role:'ROLE_PACIENTES'},
            { title: 'Consulta', icon: 'mdi-calendar-account', route: '/consulta',role:'ROLE_PACIENTES'},
            { title: 'Cirugía', icon: 'mdi-doctor', route: '/cirugia',role:'ROLE_PACIENTES'},
            { title: 'CEyE', icon: 'mdi-gauge', route: '/ceye',role:'ROLE_PACIENTES'},
            { title: 'Imagenología', icon: 'mdi-radiology-box-outline', route: '/rayosx',role:'ROLE_PACIENTES'},
            { title: 'Laboratorio', icon: 'mdi-flask', route: '/laboratorio',role:'ROLE_LABORATORIO'},
            { title: 'Presupuestos', icon: 'mdi-currency-usd', route: '/presupuestos',role:'ROLE_LABORATORIO'},
            { title: 'Biomédica', icon: 'mdi-hammer-screwdriver', route: '/biomedica',role:'ROLE_PACIENTES'},
            { title: 'Calidad', icon: 'mdi-calendar-month', route: '/calidad/reuniones',role:'ROLE_CALIDAD'},
            { title: 'Cocina', icon: 'mdi-countertop', route: '/cocina',role:'ROLE_COCINA'},
            { title: 'Lavanderia', icon: 'mdi-washing-machine', route: '/lavanderia',role:'ROLE_LAVANDERIA'},
            { title: 'Mantenimiento', icon: 'mdi-engine', route: '/mantenimiento',role:'ROLE_MTTO'},
            { title: 'Trasp. Cornea', icon: 'mdi-eye', route: '/trascor', role:'ROLE_TRASCOR'},
            { title: 'Capacitación', icon: 'mdi-school', route: '/capacita', role:'ROLE_PACIENTES'},
            { title: 'Ortopac', icon: 'mdi-android', route: '/ortopac', role:'ROLE_ORTOPAC'},
            { title: 'Roles Enf', icon: 'mdi-calendar-account', route: '/admin/personal/roles', role:'ROLE_ADMIN'},
        ],
        gabinete:[
            { title: 'Imagenologia', icon: 'mdi-radiology-box', route: '/gabinete/imagenologia',role:'ROLE_PACIENTES'},
            { title: 'Presupuestos', icon: 'mdi-cash', route: '/gabinete/presupuestos',role:'ROLE_PACIENTES'},
        ]
    }),
    computed:{
        drawer:{
            get(){
                return this.drawerNavega
            },
            set(value){
                this.$emit('update:drawerNavega',value)
            },
        },
        isLogged(){
            //console.log(this.$store.getters['security/isLogedIn'])
            return this.$store.getters['security/isLogedIn']
        },
    },
}
</script>

<style>

</style>